// Cambiar la propia contraseña.
//
// Existe porque el seed crea usuarios con una clave de desarrollo que está en
// el repo: cualquiera que pueda leer el código podría entrar. Sin esta
// pantalla, "cambiala en el primer ingreso" era una instrucción imposible de
// cumplir.
import { useState } from 'react';
import { api } from '../api';

export function CambiarClave() {
  const [actual, setActual] = useState('');
  const [nueva, setNueva] = useState('');
  const [repetir, setRepetir] = useState('');
  const [error, setError] = useState('');
  const [aviso, setAviso] = useState('');
  const [enviando, setEnviando] = useState(false);

  async function enviar(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setAviso('');

    // Se compara acá para no mandar al servidor algo que ya sabemos mal, y
    // porque el error tiene que salir junto al campo que lo causa.
    if (nueva !== repetir) { setError('Las dos contraseñas nuevas no coinciden.'); return; }

    setEnviando(true);
    try {
      const r = await api.post<{ otrasSesionesCerradas: number }>('/api/yo/clave', {
        claveActual: actual, claveNueva: nueva,
      });
      setAviso(
        'Contraseña cambiada.' +
        (r.otrasSesionesCerradas
          ? ` Se cerraron ${r.otrasSesionesCerradas} sesión(es) tuya(s) en otros navegadores.`
          : ''),
      );
      setActual(''); setNueva(''); setRepetir('');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'No se pudo cambiar la contraseña.');
    } finally {
      setEnviando(false);
    }
  }

  return (
    <>
      <h2 className="seccion">
        <span className="num">E</span>MI CONTRASEÑA
        <span className="muted">— cambiala si todavía tenés la inicial</span>
      </h2>
      <div className="kb">
        <div className="pad">
          <p className="muted" style={{ marginTop: 0, maxWidth: '52ch' }}>
            Los usuarios se crearon con una contraseña provisoria que figura en
            el código del sistema. Mientras no la cambies, cualquiera que pueda
            leer el código puede entrar con tu usuario.
          </p>

          <form onSubmit={enviar} style={{ maxWidth: 340 }}>
            <label htmlFor="cc-actual">Contraseña actual</label>
            <input id="cc-actual" type="password" value={actual} autoComplete="current-password"
                   onChange={(e) => setActual(e.target.value)} required
                   style={{ width: '100%', marginBottom: 10 }} />

            <label htmlFor="cc-nueva">Contraseña nueva</label>
            <input id="cc-nueva" type="password" value={nueva} autoComplete="new-password"
                   onChange={(e) => setNueva(e.target.value)} required minLength={10}
                   style={{ width: '100%' }} />
            <p className="muted" style={{ margin: '3px 0 10px' }}>Al menos 10 caracteres.</p>

            <label htmlFor="cc-repetir">Repetila</label>
            <input id="cc-repetir" type="password" value={repetir} autoComplete="new-password"
                   onChange={(e) => setRepetir(e.target.value)} required
                   style={{ width: '100%', marginBottom: 14 }} />

            <button className="btn-run" type="submit"
                    disabled={enviando || !actual || nueva.length < 10}>
              {enviando ? 'Cambiando…' : 'Cambiar mi contraseña'}
            </button>
          </form>

          {error && <div className="aviso bad" role="alert">{error}</div>}
          {aviso && <div className="aviso ok" role="status">{aviso}</div>}
        </div>
      </div>
    </>
  );
}
